/* eslint-disable react/prop-types */
import { Button, Card, Form, Select, Tag } from "antd";
import type { SelectProps } from "antd";
import useGeneralApi from "views/Settings/General/hooks/useGeneralApi";
import useSettingsStore from "views/hooks/useSettingsStore";
import { FaRulerCombined } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import CardTitle from "components/CardTitle";

type TagRenderProps = Parameters<NonNullable<SelectProps["tagRender"]>>[0];

export default function UnitMeasures(): React.ReactElement {
  const { t } = useTranslation();
  const location = useLocation();

  const unitMeasures = useSettingsStore(state => state.unitMeasures);

  const { listUnitMeasures } = useGeneralApi();

  const tabName = location.pathname.split("/").pop();

  useEffect(() => {
    if (tabName === "formats")
      listUnitMeasures({
        variables: {
          filter: {},
        },
      });
  }, [tabName]);

  const tagRender = (props: TagRenderProps) => {
    const { label, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <Tag
        color={"#3e849e"}
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{ marginRight: 3 }}
      >
        {label}
      </Tag>
    );
  };
  const handleFilterOption = (input: string, option?: { label?: string }) => {
    return (option?.label?.toLowerCase().indexOf(input.toLowerCase()) ?? -1) >= 0;
  };

  const form = Form.useFormInstance();

  const handleDeselectAll = () => {
    form.setFieldsValue({ unitMeasures: [] });
  };

  const selectedValues = Form.useWatch("unitMeasures", form) || [];

  const sortedUnitMeasures = [...unitMeasures].sort((a, b) => {
    const labelA = typeof a.label === "string" ? a.label : "";
    const labelB = typeof b.label === "string" ? b.label : "";
    return labelA.localeCompare(labelB);
  });

  return (
    <Card
      title={<CardTitle icon={<FaRulerCombined />} title={t("Units of measure")} />}
      className="antd-newrai-card"
    >
      {selectedValues.length > 0 && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
          <Button type="link" onClick={handleDeselectAll} size="small">
            {t("Deselect all")}
          </Button>
        </div>
      )}
      <Form.Item
        name="unitMeasures"
        rules={[{ required: true, message: t("This field is required") }]}
        label={t("Units of measure")}
      >
        <Select
          mode="multiple"
          filterOption={handleFilterOption}
          tagRender={tagRender}
          options={sortedUnitMeasures}
        />
      </Form.Item>
    </Card>
  );
}
